"use client";
import style from "@/app/style/state.module.css";
import { useState, useEffect } from "react";
import { FaSearch } from "react-icons/fa";
// Adjust the path based on where your JSON file is located
import First from "../../../public/updated-home/blogs/first.png";
import Image from "next/image";
function Hero({ onSearch }) {
  const [selectedOption, setSelectedOption] = useState("pointToPoint");
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredData, setFilteredData] = useState([]);

  const handleChange = (event) => {
    setSearchTerm(event.target.value);
    onSearch(event.target.value); // Call the onSearch callback with the search term
  };

  const handleOptionClick = (option) => {
    setSelectedOption(option);
  };

  const home = [
    {
      image: "blogsHeader",
    },
  ];

  const services = [
    "Black Car Service",
    "Airport Car Service",
    "City to City Rides",
    "Chauffeur Services",
    "Hourly Hire",
    "City Tours",
    "Special Events",
    "Point to Point Car Service",
    "Corporate  Airport Transfers",
    "Client & Partner Travel",
    "Corporate Event Transportation",
    "Meetings & Offsite Events",
    // Add more services here if needed
  ];

  return (
    <div>
      <div className="mx-auto max-w-7xl headerpxset">
        {home.map((object) => (
          <div
            key={object.image}
            style={{
              display: "flex",
              alignItems: "flex-end",
              justifyContent: "center",
              paddingBottom: "50px",
            }}
            className={style[object.image]}
          >
            <div
              className="relative flex items-center justify-center bg-cover bg-center h-40"
              style={{
                backgroundImage: "url('/path-to-your-background-image.jpg')",
              }}
            >
              <h1 className="text-white text-3xl font-bold absolute top-5">
                Blogs
              </h1>
              <div className="flex items-center mt-10 h-[50px] px-3 bg-white rounded">
                <div className="px-2">
                  <FaSearch className="text-gray-400" />
                </div>
                <input
                  type="text"
                  placeholder="Search"
                  className="w-full text-gray-700 focus:outline-none"
                  value={searchTerm}
                  onChange={handleChange}
                />
                {/* <div className="relative inline-block">
                  <select className="w-full bg-white flex justify-center pl-10 text-gray-700 focus:outline-none appearance-none">
                    <option>All Categories</option>
                    {services.map((service, index) => (
                      <option key={index} value={service}>
                        {service}
                      </option>
                    ))}
                  </select>
                  <div className="absolute inset-y-0 right-0 flex items-center px-2 pointer-events-none">
                    <svg
                      className="w-4 h-4 text-gray-400"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M19 9l-7 7-7-7"
                      />
                    </svg>
                  </div>
                </div> */}
              </div>
            </div>
          </div>
        ))}

        {/* Displaying filtered results */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mt-10 ">
          {filteredData.map((item, index) => (
            <div
              key={index}
              style={{ border: "1px solid #2B3252" }}
              className=" rounded-2xl mb-3 relative"
            >
              <div className="absolute flex z-10 top-[-20px] left-10">
                <svg
                  width="87"
                  height="70"
                  viewBox="0 0 87 70"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M13.5 0H86.5L73 20H0L13.5 0Z" fill="#9E8228" />
                  <path d="M14 0H86V70H14V0Z" fill="#D5AF34" />
                </svg>
                <div className="absolute flex flex-col items-center top-[10px] left-[35px]">
                  <span className="text-xl font-bold text-[#2B3252]">
                    {item.date.day}
                  </span>
                  <br />
                  <span className="mt-[-26px]">{item.date.month}</span>
                </div>
              </div>

              <div className="p-3">
                <div className="relative">
                  <Image
                    src={item.image}
                    alt="Car Service"
                    width={600}
                    height={400}
                    className="w-full rounded-2xl"
                  />
                </div>

                <div className="text-[#2B3252]">
                  <div className="bg-[#E9EDFF] font-base font-normal mt-3 px-2 py-1 rounded-md inline-block mb-2">
                    {item.title}
                  </div>
                  <h3 className="text-xl font-bold mb-2">{item.description}</h3>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Hero;
